import React, { useEffect, useState } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { addNotification } from "./notificationsStore";
import { useNavigate } from "react-router-dom";

export default function AdminSubs() {
  const [subs, setSubs] = useState([]);
  const [filter, setFilter] = useState("all");
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  async function loadSubs() {
    try {
      const token = localStorage.getItem("membreToken");

      if (!token) {
        navigate("/login");
        return;
      }

      const res = await fetch(
        "/api/admin/members?type=subscriptions",
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      if (res.status === 403) {
        localStorage.removeItem("membreToken");
        navigate("/login");
        return;
      }

      const result = await res.json();

      if (!result.success) {
        toast.error("Erreur lors du chargement");
        return;
      }

      let data = result.data || [];

      
      if (filter !== "all") {
        data = data.filter(
          (s) => s.approved === (filter === "approved")
        );
      }

      if (search.trim()) {
        data = data.filter((s) =>
          s.email.toLowerCase().includes(search.toLowerCase())
        );
      }

      setSubs(data);

    } catch (err) {
      toast.error("Erreur lors du chargement");
    }
  }

  useEffect(() => {
    loadSubs();
  }, [filter, search]);

  async function toggle(id, current, email) {
  const token = localStorage.getItem("membreToken");

  const res = await fetch("/api/admin/members?type=toggleSub", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify({ id, approved: !current }),
  });

  const data = await res.json();

  if (!data.success) return toast.error("Erreur");

  addNotification(
    !current
      ? `Nouvel abonné approuvé : ${email}`
      : `Abonné désapprouvé : ${email}`
  );

  toast.success(!current ? "Approuvé" : "Désapprouvé");

  loadSubs();
}


  function exportExcel() {
    const data = subs.map((s) => ({
      Email: s.email,
      Approuvé: s.approved ? "Oui" : "Non",
      Date: s.created_at,
    }));

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Abonnés");

    saveAs(
      new Blob([XLSX.write(wb, { bookType: "xlsx", type: "array" })]),
      "subs.xlsx"
    );
  }

  return (
    <div className="p-4 space-y-6">

      <h1 className="text-2xl font-bold dark:text-white">
        Gestion des abonnés
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">

        <input
          placeholder="Rechercher email…"
          className="px-3 py-2 border dark:border-gray-700 rounded-lg 
                     dark:bg-gray-800 dark:text-white"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          className="px-3 py-2 border dark:border-gray-700 rounded-lg
                     dark:bg-gray-800 dark:text-white"
        >
          <option value="all">Tous</option>
          <option value="approved">Approuvés</option>
          <option value="pending">En attente</option>
        </select>

        <button
          onClick={exportExcel}
          className="px-4 py-2 bg-blue-600 rounded-lg text-white w-full 
                     hover:bg-blue-700 transition"
        >
          Exporter Excel
        </button>

      </div>

      <div className="space-y-4">

        <div className="grid md:hidden gap-4">
          {subs.map((s) => (
            <div
              key={s.id}
              className="p-4 rounded-lg shadow bg-white dark:bg-gray-900 border dark:border-gray-700"
            >
              <p className="font-semibold dark:text-white">{s.email}</p>

              <p className="text-sm mt-1 dark:text-gray-300">
                {new Date(s.created_at).toLocaleString()}
              </p>

              <span
                className={`inline-block mt-2 px-2 py-1 text-xs rounded 
                  ${s.approved ? "bg-green-600 text-white" : "bg-yellow-500 text-white"}`}
              >
                {s.approved ? "Approuvé" : "En attente"}
              </span>

              <button
                onClick={() => toggle(s.id, s.approved, s.email)}
                className={`w-full mt-3 px-3 py-2 rounded-lg text-white font-semibold
                  ${s.approved
                    ? "bg-red-600 hover:bg-red-700"
                    : "bg-green-600 hover:bg-green-700"}`}
              >
                {s.approved ? "Désapprouver" : "Approuver"}
              </button>
            </div>
          ))}
        </div>

        <div className="hidden md:block bg-white dark:bg-gray-900 rounded-lg shadow overflow-auto">
          <table className="w-full">
            <thead className="bg-gray-100 dark:bg-gray-800 text-left">
              <tr>
                <th className="p-3">Email</th>
                <th className="p-3">Approuvé</th>
                <th className="p-3">Date</th>
                <th className="p-3">Action</th>
              </tr>
            </thead>

            <tbody>
              {subs.map((s) => (
                <tr key={s.id} className="border-t dark:border-gray-700">
                  <td className="p-3">{s.email}</td>
                  <td className="p-3">{s.approved ? "Oui" : "Non"}</td>
                  <td className="p-3">
                    {new Date(s.created_at).toLocaleString()}
                  </td>
                  <td className="p-3">
                    <button
                      onClick={() => toggle(s.id, s.approved, s.email)}
                      className={`px-3 py-2 rounded-lg text-white font-semibold
                        ${s.approved
                          ? "bg-red-600 hover:bg-red-700"
                          : "bg-green-600 hover:bg-green-700"}`}
                    >
                      {s.approved ? "Désapprouver" : "Approuver"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>

      </div>
    </div>
  );
}
